import React from "react";
import { SkeletonBlock } from "./SkeletonUI";

const IpSkeletonLoader = () => (
  <section className="container" style={{ padding: "72px 0 80px" }}>
    {/* Section label + heading */}
    <SkeletonBlock width={80} height={10} style={{ marginBottom: 12 }} />
    <SkeletonBlock width={180} height={34} style={{ marginBottom: 48 }} />

    {/* Grid of product cards */}
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
      gap: 20,
    }}>
      {[0, 1, 2, 3].map(i => (
        <div key={i} style={{
          borderRadius: 14,
          padding: "32px 24px 28px",
          border: "1px solid #f0f0f0",
          background: "#fafafa",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
        }}>
          <SkeletonBlock width={120} height={60} radius={8} />
          <SkeletonBlock height={18} style={{ width: "80%" }} />
          <SkeletonBlock width="50%" height={18} />
          <SkeletonBlock width={80} height={13} />
        </div>
      ))}
    </div>
  </section>
);

export default IpSkeletonLoader;
